let apiOrigins = {
  localhost: {
    paywall: 'http://localhost:64184',
    ingresar: 'http://localhost:17927'
  },
  qa: 'https://qa-api-{app}.lanacion.com.ar',
  pre: 'https://pre-api-{app}.lanacion.com.ar',
  beta: 'https://beta-api-{app}.lanacion.com.ar',
  prod: 'https://api-{app}.lanacion.com.ar'
}

let apiOriginsNew = {
  localhost: {
    authorization: 'https://qa-{app}.lanacion.com.ar/api'
  },
  qa: 'https://qa-{app}.lanacion.com.ar/api',
  pre: 'https://pre-{app}.lanacion.com.ar/api',
  beta: 'https://pre-{app}.lanacion.com.ar/api',
  prod: 'https://{app}.lanacion.com.ar/api',
}

let lnOrigins = {
  localhost: 'https://swg-ln9.lanacion.com.ar',
  qa: 'https://swg-ln9.lanacion.com.ar',
  pre: 'https://www.lanacion.com.ar',
  beta: 'https://www.lanacion.com.ar',
  prod: 'https://www.lanacion.com.ar',
}

let domain = window.location.origin.includes('localhost') ? 'localhost' : '.lanacion.com.ar';
let lnUrl = lnOrigins[getEnvironment()];


function getApiEnvironment(api) {
  return getApiEnvironmentByOrigin(api, apiOrigins);
}

function getApiEnvironmentNewUrl(api) {
  return getApiEnvironmentByOrigin(api, apiOriginsNew);
}

function getApiEnvironmentByOrigin(api, _apiOrigins) {

  if (window.location.origin.includes('localhost')) {
    let url = "";
    switch (api) {
      case 'paywall':
        url = _apiOrigins.localhost.paywall.replace('{app}', api);
        break;
      case 'ingresar':
        url = _apiOrigins.localhost.ingresar.replace('{app}', api);
        break;
      case 'authorization':
        url = _apiOrigins.localhost.authorization.replace('{app}', api);
        break;
      default:
        throw new Error("api no configurada en localhost" + api);
        break;
    }
    return url;
  }
  if (window.location.origin.includes('qa') || window.location.origin.includes('swg-ln9')) {
    return _apiOrigins.qa.replace('{app}', api);
  }
  if (window.location.origin.includes('pre')) {
    return _apiOrigins.pre.replace('{app}', api);
  }
  if (window.location.origin.includes('beta')) {
    return _apiOrigins.beta.replace('{app}', api);
  }

  return _apiOrigins.prod.replace('{app}', api);
}

function getEnvironment() {
  if (window.location.origin.includes('qa')) {
    return 'qa';
  }
  if (window.location.origin.includes('pre')) {
    return 'pre';
  }
  if (window.location.origin.includes('beta')) {
    return 'beta';
  }
  if (window.location.origin.includes('localhost')) {
    return 'localhost';
  }
  return 'prod';
}

module.exports = {
  cookies: [
    'usuariosexo',
    'usuarioemail',
    'usuarioanio',
    'usuarioDetalleClubNacion',
    'UsuarioDetalleGuid',
    'UsuarioDetalleNick',
    'UsuarioId',
    'UsuarioUsuario',
    'usuario%5Fusuario',
    'usuarioLogTkn',
    'cookieLogin',
    'syncLfLN',
    'tieneClub',
    'Provinciaid',
    'Paisid',
    'LNPreferencias',
    'Crm_id',
    'ProductoPremiumId',
    'token',
    'xvalue',
    'TokenJWT'
  ],
  swgPreventLoginCookie: "SWGPreventLogin",
  dominio: domain,
  expirationcookie: '8640000',
  api: {
    login: getApiEnvironment('ingresar'),
    paywall: getApiEnvironment('paywall'),
    authorization: getApiEnvironmentNewUrl('authorization')
  },
  lnUrl: lnUrl,
  SitioId: '1',
  authCookie: 'metering_arc',
  authDownCookie: 'MeteringCookieServiceDown',
  authDownCookieExpiration : 600,
  tokenCookie: 'token'
}




// WEBPACK FOOTER //
// ./~/@ln/registracionlibs/src/core/config.js